import React from "react";
import Button from "components/CustomButtons/Button.jsx";
import { FormControl, InputLabel, Grid } from "@material-ui/core";
import classNames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";
import AutocompleteSelect from "../../utils/AutocompleteSelect";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  root: {
    flexGrow: 1,
    paddingLeft: "15px"
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 100
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 1
  },
  searchButton: {
    backgroundColor: " #66bb6a"
  },
  airlineSelect: { marginTop: "0px", width: "100%" },
  Grid: {
    flexBasis: "14px"
  }
});

const SearchPanel = props => {
  let { entities, onSearch, selectChange, classes, Status } = props;

  return (
    <div>
      <Grid container spacing={24}>
        <Grid item md={4}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Entities
            </InputLabel>
            <AutocompleteSelect
              options={entities.map(option => ({
                value: option.EntityTypeId,
                label: option.EntityType
              }))}
              name={"EntityId"}
              handleSelectChange={(e, name) => selectChange(e, name)}
            />
            {/*<Select*/}
            {/*value={EntityId}*/}
            {/*onChange={selectChange}*/}
            {/*input={<Input name="entity" id="entity-label-placeholder" />}*/}
            {/*name="EntityId"*/}
            {/*className={classes.selectEmpty}*/}
            {/*>*/}
            {/*<MenuItem value="-1">All Entities</MenuItem>*/}
            {/*{entities.map((option, i) => (*/}
            {/*<MenuItem*/}
            {/*key={i}*/}
            {/*value={option.EntityTypeId}*/}
            {/*className={classes.select}*/}
            {/*>*/}
            {/*{option.EntityType}*/}
            {/*</MenuItem>*/}
            {/*))}*/}
            {/*</Select>*/}
          </FormControl>
        </Grid>
        <Grid item md={4}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Status
            </InputLabel>
            <AutocompleteSelect
              options={Status.map(option => ({
                value: option.Id_,
                label: option.Name
              }))}
              name={"statusId"}
              handleSelectChange={(e, name) => selectChange(e, name)}
            />
            {/*<Select*/}
            {/*value={statusId}*/}
            {/*onChange={selectChange}*/}
            {/*input={<Input name="entity" id="entity-label-placeholder" />}*/}
            {/*name="statusId"*/}
            {/*className={classes.selectEmpty}*/}
            {/*>*/}
            {/*<MenuItem value="-1">All Status</MenuItem>*/}
            {/*{Status.map((option, i) => (*/}
            {/*<MenuItem*/}
            {/*key={i}*/}
            {/*value={option.Id_}*/}
            {/*className={classes.select}*/}
            {/*>*/}
            {/*{option.Name}*/}
            {/*</MenuItem>*/}
            {/*))}*/}
            {/*</Select>*/}
          </FormControl>
        </Grid>
        <Grid item md={2}>
          <Button color={"primary"} onClick={() => onSearch()}>
            Search
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styles)(SearchPanel);

/* Written with love by Juliet April 2019*/



// WEBPACK FOOTER //
// ./src/views/MakerChecker/search_panel.js